import type * as React from "react";
import {
  FieldError as AriaFieldError,
  type FieldErrorProps,
} from "react-aria-components";
import { error } from "./FieldError.css.ts";
import type { OmittedReactAriaProps } from "./types.ts";

export type Props = Omit<FieldErrorProps, OmittedReactAriaProps> & {
  /** Ref to the underlying element. */
  ref?: React.Ref<HTMLElement>;
};

/**
 * Displays validation error messages for form fields.
 * Typically used within form field components to show error state.
 */
export const FieldError: React.FC<Props> = ({ ref, ...props }) => (
  <AriaFieldError ref={ref} className={error} {...props} />
);
